import { FC, ReactNode } from 'react'
import { JobOption, JobOptionType } from './Option'
import { JobTag, JobTagType } from './Tag'

import { Form, FormType } from './form/Form'

export const Job: FC &
  JobTagType &
  JobOptionType &
  FormType = (): ReactNode => <></>

Job.Tag = JobTag
Job.Option = JobOption
Job.Form = Form
